import(/* webpackMode: "eager" */ "/Users/carl/Source/Repos/ThreadHound/pw.community.bot/app/(shopfront)/pricing/page.tsx");
